const PdpEntry = () => import(/* webpackChunkName: "pdp" */ './PdpEntry');

export default [{
  path: '/product/:urlKey',
  name: 'pdpPage',
  component: PdpEntry,
  meta: {
    noScroll: true
  },
  props: true
}];
